import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Our Presence', path: '/presence' },
    { name: 'Careers', path: '/careers' },
    { name: 'Contact', path: '/contact' },
  ];

  const services = [
    'Audit & Assurance',
    'Taxation Services',
    'Advisory & Compliance',
    'Financial Consulting',
    'Technology & Analytics',
  ];

  return (
    <footer className="bg-navy text-white">
      <div className="container mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <img 
              src="/header-logo.png" 
              alt="D P Sarda & Co. - Chartered Accountants"
              className="h-16 mb-4"
            />
            <p className="text-gray-300 mb-4 leading-relaxed">
              Your Goals. Our Grit.
            </p>
            <p className="text-gray-400 text-sm mb-6">
              Over 31 years of excellence in providing reliable and innovative financial solutions.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-6 font-serif">Quick Links</h3>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-gray-300 hover:text-emerald transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-6 font-serif">Our Services</h3>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service}>
                  <Link to="/services" className="text-gray-300 hover:text-emerald transition-colors">
                    {service}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-6 font-serif">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone size={18} className="text-gold mt-1 flex-shrink-0" />
                <a href="tel:8788534309" className="text-gray-300 hover:text-emerald transition-colors">
                  87885 34309
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={18} className="text-gold mt-1 flex-shrink-0" />
                <a href="mailto:office@cadpsarda.com" className="text-gray-300 hover:text-emerald transition-colors break-all">
                  office@cadpsarda.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-gold mt-1 flex-shrink-0" />
                <span className="text-gray-300">
                  Nagpur | Mumbai | Kishangarh
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-700">
        <div className="container mx-auto px-6 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400">
            <div>
              © {currentYear} D P Sarda & Co. All rights reserved. | ICAI Registered Chartered Accountants
            </div>
            <div className="flex gap-6">
              <a href="#" className="hover:text-emerald transition-colors">Privacy Policy</a>
              <a href="#" className="hover:text-emerald transition-colors">Terms of Service</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;